import { LoadingScreen } from '@avanta/shared/components/LoadingScreen';
import { AM_XL_WIDTH_PX } from '@avanta/shared/constants/common';
import { useNewConversationListener } from '@avanta/shared/hooks/chat/useNewConversationListener';
import { useConversationsStore } from '@avanta/shared/stores/chat/conversations';
import { useChatStore } from '@avanta/shared/stores/chat/index';
import { cn } from '@avanta/shared/utils/cn';
import { TopNav } from 'components/TopNav';
import { useWindowWidth } from 'hooks/useWindowWidth';
import { useIsPatientOrEmployee } from 'stores/user';
import { Conversation } from './components/Conversation';
import { Sidebar } from './components/Sidebar';
import { UserInfo } from './components/UserInfo';
import { useChatInitializer } from './hooks/useChatInitializer';

const ChatContent = (): React.ReactElement => {
  const isInitialized = useChatStore(state => state.isInitialized);
  const activeChannelId = useConversationsStore(state => state.activeChannelId);
  const isOpenInfo = useConversationsStore(state => state.isOpenInfo);
  const isLoadingConversations = useConversationsStore(state => state.isLoading);
  const isPatientOrEmployee = useIsPatientOrEmployee();
  const { width } = useWindowWidth();
  const isDesktop = width > AM_XL_WIDTH_PX;
  const isBootstrapping = !isInitialized || isLoadingConversations;

  if (isBootstrapping) {
    return <LoadingScreen />;
  }

  if (isDesktop) {
    return (
      <div className="flex min-h-0 flex-1 flex-row">
        {!isPatientOrEmployee && <Sidebar />}
        <Conversation />
        {isOpenInfo && <UserInfo />}
      </div>
    );
  }

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      {!activeChannelId && !isPatientOrEmployee ? (
        <Sidebar />
      ) : isOpenInfo && !isPatientOrEmployee ? (
        <UserInfo />
      ) : (
        <Conversation />
      )}
    </div>
  );
};

export const Chat = (): React.ReactElement => {
  useChatInitializer();
  useNewConversationListener();
  const isPatientOrEmployee = useIsPatientOrEmployee();
  return (
    <div
      className={cn(
        'flex h-dvh flex-col mx-auto max-w-7xl am-xl:pb-4',
        isPatientOrEmployee && 'xl:pb-6 am-xl:pb-0'
      )}
    >
      <TopNav />
      <ChatContent />
    </div>
  );
};
